import { MPCIGridRow } from "../typings/iGridRow";
import { MPCEventBus } from "../../helpers/event-bus";
import { MPCValuesRowModule } from "./valuesRow";
import { MPCRowField } from "./rowField";
import { MPCToolTip } from "../../helpers/toolTip";
const ArrowUpIcon = require("../../../images/arrow-up.svg") as string;

export module MPCRowContainerModule {
    import IGridRow = MPCIGridRow.IGridRow;
    import EventBus = MPCEventBus.EventBus;
    import ValuesRow = MPCValuesRowModule.ValuesRow;
    import ToolTip = MPCToolTip.ToolTip;

    export class RowContainer implements IGridRow {
        private htmlElement: HTMLElement;
        public headLineTitleHtmlElement: HTMLElement;
        private eventBus: EventBus;
        private arrowUp: HTMLElement;
        private valuesRowArray: ValuesRow[];
        public rowValuesAreEqual: boolean;
        public mpcModalContainer: HTMLElement;

        public init(rowContainer: HTMLElement, filledColumns: number, mpcModalContainer: HTMLElement, categoryName: string): void {
            this.htmlElement = rowContainer;
            this.headLineTitleHtmlElement = this.htmlElement.querySelector('.head-line-title');
            this.mpcModalContainer = mpcModalContainer;

            const valuesRows: NodeListOf<HTMLElement> = this.htmlElement.querySelectorAll('.row-values');
            const valuesRowArray: Array<HTMLElement> = Array.prototype.slice.call(valuesRows);

            this.valuesRowArray = valuesRowArray.map(row => {
                        const rowValues = new ValuesRow();
                        rowValues.resolveRowFields(row, filledColumns, this, categoryName);
                        return rowValues;
                     });

            this.eventBus = MPCEventBus.EventBus.instance;

            // header row do not have title:
            if(!this.headLineTitleHtmlElement) return;

            this.arrowUp = this.headLineTitleHtmlElement.querySelector('.mpc-arrow-up');
            
            if(this.arrowUp)
                this.arrowUp.innerHTML = ArrowUpIcon;

            this.registerEvents();
            this.hideRowWhereAllValuesAreEmpty();
        }

        private registerEvents(): void {
            // add toolTip hover event handlers:
            if(!this.headLineTitleHtmlElement.classList.contains(MPCRowField.PermanentlyHidden)) {
                const tooltipContainer: HTMLElement = this.headLineTitleHtmlElement.querySelector('.tooltip-container');

                if (tooltipContainer) {
                    new ToolTip(tooltipContainer, this.mpcModalContainer);
                }
            }

            this.headLineTitleHtmlElement.addEventListener('click', () => { this.handleArrowClick(); });
            this.headLineTitleHtmlElement.addEventListener('keydown', (event: any) => {
                // prevent page jump down on Space btn., click
                if (event.code === 'Space')
                    event.preventDefault(); 
            });
        }

        private handleArrowClick(): void {
            this.arrowUp.classList.toggle('rotate-arrow');
            const collapseRow: boolean = this.arrowUp.classList.contains('rotate-arrow');
            this.collapseExpandValuesRow(collapseRow, false);
            this.eventBus.publish('filter-row.is-expanded', !collapseRow);
        }

        public triggerCollapseExpandRow(collapseRow: boolean, delayExecution: boolean = false): void {
            // sub filter does not have arrow icon
            if (this.arrowUp) {
                if (collapseRow) {
                    this.arrowUp.classList.add('rotate-arrow');
                }
                else {
                    this.arrowUp.classList.remove('rotate-arrow');
                }

                this.collapseExpandValuesRow(collapseRow, delayExecution);
            }
        }

        private collapseExpandValuesRow(collapseRow: boolean, delayExecution: boolean = false): void {
            let delay = 0;
            let step = 10;

            for (const valuesRow of this.valuesRowArray) {
                if (delayExecution) {
                    // This way is needed to fix some slow browser animation trouble
                    setTimeout(() => { valuesRow.collapseExpandRow(collapseRow); }, delay);
                    delay = delay + step;
                } else {
                    valuesRow.collapseExpandRow(collapseRow);
                }
            }
        }

        public showOnlyDifferences(newState: boolean): void {
            const allSubRowsHidden: boolean = this.valuesRowArray.map((row) => {
                
                // do not hide controls row:
                if(row.htmlElementOrNull && row.htmlElementOrNull.classList.contains('controls')) {
                    return false;
                }

                const hidden = row.showOnlyDifferences(newState);
                return hidden
            }).reduce((prev, curr) => prev && curr, true);

            // header row do not have title:
            if(!this.headLineTitleHtmlElement)
                return;

            if (allSubRowsHidden) 
                this.headLineTitleHtmlElement.classList.add(MPCRowField.UserHidden);
            else 
                this.headLineTitleHtmlElement.classList.remove(MPCRowField.UserHidden);
        }

        private hideRowWhereAllValuesAreEmpty(): void {
            const allSubRowsHidden = this.valuesRowArray.map((row) => {
                const hidden = row.hideRowsWhereAllValuesAreEmpty();
                return hidden
            }).reduce((prev, curr) => prev && curr, true);

            if (allSubRowsHidden) {
                this.headLineTitleHtmlElement.classList.add(MPCRowField.PermanentlyHidden);
            }
        }

        public getRowValuesAreEqual(): boolean {
            //this method is used to disable the 'only differences' button
            if (this.rowValuesAreEqual === undefined) {
                this.rowValuesAreEqual = false;
            }
            return this.rowValuesAreEqual;
        }

        public setFirstAndLastClass(): void {
            const visible = this.valuesRowArray.filter(row => 
                !row.htmlElementOrNull.classList.contains(MPCRowField.PermanentlyHidden) &&
                    !row.htmlElementOrNull.classList.contains(MPCRowField.UserHidden)
            );

            this.valuesRowArray.forEach((row) => {
                row.htmlElementOrNull.classList.remove("first", "last");
            });

            if (visible.length > 0) {
                visible[0].htmlElementOrNull.classList.add("first");
                visible[visible.length - 1].htmlElementOrNull.classList.add("last");
            }
        }
    }
}